(function () {
  function initSocialProof(root) {
    var stats = Array.prototype.slice.call(root.querySelectorAll("[data-rvrn-social-stat]"));
    var title = root.querySelector("[data-rvrn-social-title]");
    var copy = root.querySelector("[data-rvrn-social-copy]");
    var rail = root.querySelector("[data-rvrn-reach-stat-rail]");
    if (!stats.length || !title || !copy) return;

    function activate(stat) {
      (rail || root).classList.add("is-changing");
      stats.forEach(function (item) {
        item.classList.toggle("is-active", item === stat);
      });
      title.textContent = stat.getAttribute("data-title") || "";
      copy.textContent = stat.getAttribute("data-copy") || "";
      window.setTimeout(function () {
        (rail || root).classList.remove("is-changing");
      }, 140);
    }

    stats.forEach(function (stat) {
      stat.addEventListener("mouseenter", function () {
        activate(stat);
      });
      stat.addEventListener("focus", function () {
        activate(stat);
      });
      stat.addEventListener("click", function () {
        activate(stat);
      });
    });
  }

  /* 「U.S. states」自动统计 block。
     归一化实现放在 assets/rvrn-us-states.js（本 Section 独有引用）。
     口径与 Section rvrn-vehicle-gallery 的 Stat 5 一致（全量有效原始记录、
     按 2 位州缩写去重）；但该 Section 目前仍自带一份等价实现、未迁移过来，
     所以两边还不是同一份代码 —— 改任何一边的口径都必须同步另一边。
     数值未到位前保持 Liquid 输出的 0，不去动它，以免出现空值造成的布局位移。 */
  function initStatesStats(sectionEl) {
    var pending = [];
    sectionEl.querySelectorAll("[data-rvrn-states-value]").forEach(function (el) {
      if (el.dataset.rvrnStatesReady === "true") return;
      pending.push(el);
    });
    if (!pending.length) return;

    if (!window.RVRNUsStates) {
      console.warn("[rvrn-social-proof-reach] states stat: rvrn-us-states.js 未加载，统计跳过");
      return;
    }

    var token = sectionEl.getAttribute("data-storefront-token");
    if (!token) {
      console.warn("[rvrn-social-proof-reach] states stat: 缺少 storefront_token，统计跳过");
      return;
    }

    window.RVRNUsStates.loadStateCount({
      token: token,
      version: sectionEl.getAttribute("data-api-version") || "2024-01",
      handle: sectionEl.getAttribute("data-states-blog") || "vehicle-gallery",
      regionMetafield: sectionEl.getAttribute("data-states-region-metafield") || "custom.customer_location"
    }).then(function (count) {
      pending.forEach(function (el) {
        el.textContent = String(count);
        // 「已处理」标记只在数值真正写入后才打。之前在取值/检查之前就打，
        // 一旦那次尝试没成功（模块未加载、请求失败），区块会被永久跳过，
        // 编辑器里就一直显示 0，直到区块 DOM 被整体替换才恢复。
        el.dataset.rvrnStatesReady = "true";
      });
    }).catch(function (err) {
      console.warn("[rvrn-social-proof-reach] states stat: 请求失败 →", err && err.message);
    });
  }

  function initAll(scope) {
    var root = scope || document;
    var sections = [];
    // scope 本身可能就是 section 根节点（主题编辑器 shopify:section:load 传入 section 元素），
    // querySelectorAll 只匹配后代，必须单独判断，否则重载后所有初始化都不会执行。
    if (root.matches && root.matches("[data-rvrn-social-proof]")) sections.push(root);
    root.querySelectorAll("[data-rvrn-social-proof]").forEach(function (el) {
      sections.push(el);
    });

    sections.forEach(function (sectionEl) {
      initSocialProof(sectionEl);
      initStatesStats(sectionEl);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
